import { z } from "zod";
import { RequestStatusSchema } from "./requests";

export const EventDateConflictQuerySchema = z.object({
  eventDate: z.string().min(1),
  endDate: z.string().nullable().optional(),
  excludeEventId: z.string().optional(),
  excludeRequestId: z.string().optional(),
});
export type EventDateConflictQueryDTO = z.infer<
  typeof EventDateConflictQuerySchema
>;

export const EventDateConflictEventItemSchema = z.object({
  kind: z.literal("event"),
  id: z.string(),
  title: z.string(),
  status: z.enum(["draft", "confirmed", "completed", "cancelled"]),
  eventDate: z.coerce.date(),
  endDate: z.coerce.date().nullable(),
});
export type EventDateConflictEventItemDTO = z.infer<
  typeof EventDateConflictEventItemSchema
>;

export const EventDateConflictRequestItemSchema = z.object({
  kind: z.literal("request"),
  id: z.string(),
  title: z.string(),
  status: RequestStatusSchema,
  requestedEventDate: z.coerce.date(),
});
export type EventDateConflictRequestItemDTO = z.infer<
  typeof EventDateConflictRequestItemSchema
>;

export const EventDateConflictItemSchema = z.discriminatedUnion("kind", [
  EventDateConflictEventItemSchema,
  EventDateConflictRequestItemSchema,
]);
export type EventDateConflictItemDTO = z.infer<
  typeof EventDateConflictItemSchema
>;

export const EventDateConflictResponseSchema = z.object({
  items: z.array(EventDateConflictItemSchema),
});
export type EventDateConflictResponseDTO = z.infer<
  typeof EventDateConflictResponseSchema
>;
